import React from 'react';
import { Tabs, TabsProps } from 'tea-component';
import './index.scss';

export default function LinkTab({
  children,
  ...props
}: {
  children: any;
} & TabsProps) {
  return (
    <Tabs animated={false} className="dbo-link-tab-wrapper" {...props}>
      {children}
    </Tabs>
  );
}
